module.exports = __webpack_public_path__ + "img/GreekTechSpearman3_ua.e9ea7261.webp";